<template>
    <div>
        <crud-facecade
            ref="drug_list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :searchLocal="true"
            :addButton="{ enabled: true}"
            :deleteButton="{ enabled: true}"
            :updateButton="{ enabled: true}"
        >

        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `TransferCirculation`,
    props: {},
    data() {
        return {
            title: `转运流转配置`,
            url: {
                baseURL: `/api/TransferEvent/TransferCirculation`
            },
            Events: [],
            TransferFlows: [],
            buttons: []
        }
    },
    created() {
        this.init()
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },

                {
                    type: `select`,
                    prop: `dic_transfer_flow_id`,
                    label: `所属流程`,
                    isListable: true,
                    sortable: true,
                    isCreatable: true,
                    isEditable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: this.TransferFlows
                }, {
                    type: `select`,
                    prop: `dic_event_id`,
                    label: `事件名称`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: this.Events
                },
                {
                    type: `string`,
                    prop: `button_name`,
                    label: `按钮名称`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    searchable: false
                }, {
                    type: `string`,
                    prop: `data_state_name`,
                    label: `数据状态名称`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    searchable: false
                }, {
                    type: `multiselect`,
                    prop: `worker_role_arr`,
                    label: `所属角色`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: this.sys_enums.Enum_WorkerRole
                }, {
                    type: `select`,
                    prop: `is_same_skip`,
                    label: `是否同一角色跳过`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: `enum_bool`,
                    default: true
                }, {
                    type: `select`,
                    prop: `is_alow_withdraw`,
                    label: `是否允许撤回`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: `enum_bool`,
                    default: true
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `select`,
                    prop: `is_enable`,
                    label: `是否启用`,
                    width: `120`,
                    isListable: true,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: `enum_bool`,
                    default: true
                },
                {
                    type: `colorpicker`,
                    prop: `color`,
                    label: `颜色`,
                    width: `180`,
                    isListable: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `doc_code`,
                    label: `文书编号`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `textarea`,
                    prop: `message_template`,
                    label: `消息模板`,
                    config: {
                        minRows: 2
                    },
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24
                }
            ]
        }
    },
    mounted() {},
    methods: {
        init() {
            let req = this.myaxios.get(`/api/AcisSystem/Event/GetByType?eventtype=3`)
            req.then(data => {
                console.log(`GetByType`, data)
                this.Events = _.map(data, d => {
                    return { value: d.id, label: d.name, jianpin: d.abbr }
                })
            }).catch(e => {
                console.log(e)
            })

            let req2 = this.myaxios.get(`/api/TransferEvent/TransferFlow/Get`)
            req2.then(data => {
                console.log(`TransferFlow`, data)
                this.TransferFlows = _.map(data, d => {
                    return { value: d.id, label: d.flow_name }
                })
                console.log(`TransferFlow`, this.TransferFlows)
            }).catch(e => {
                console.log(e)
            })
        },
        refreshList() {
            this.$refs[`drug_list`].ReloadListData()
        },
        runCarteServer() {
            let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_dic_drug&paramStr=1`)
            req.then(data => {
                this.$refs[`drug_list`].ReloadListData()
            }).catch(e => {
                console.log(e)
            })
        },
        loadAllDrugWay() {
            let req = this.myaxios.get(`/api/AcisSystem/AddDrugWay/GetAll`)
            req.then(data => {
                this.allDrugWay = _.map(data, d => {
                    return {
                        label: `${d.name}`,
                        value: d.id,
                        jianpin: d.code,
                        disabled: d.is_deleted
                    }
                })
            }).catch(error => {
                console.log(error)
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/TransferCirculation/Index.vue